var _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSephira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 72,
    viewBox: "0 0 143 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 142,
    height: 71,
    rx: 9.5,
    fill: "white",
    stroke: "#12489E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 12,
    width: 103,
    height: 45,
    fill: "url(#pattern0_115_103)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_115_103",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_115_103",
    transform: "scale(0.00970874 0.0222222)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_115_103",
    width: 103,
    height: 45,
    xlinkHref: "data:image/jpeg;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSephira);
export default __webpack_public_path__ + "static/media/sephira.44fbe8c0128bb6bd83878633133fafd4.svg";
export { ForwardRef as ReactComponent };